import { useContext } from 'react'
import { GrowthBookContext } from '@growthbook/growthbook-react'
import { forcedFeatureFlags, parseForcedFeatureFlags } from '@/app/lib/featureFlags'

export { parseForcedFeatureFlags }

export function useFeatureFlag(featureId: string): boolean {
    // useGrowthBook() throws outside a provider; the raw context defaults to {} instead
    const { growthbook } = useContext(GrowthBookContext)

    if (forcedFeatureFlags.has(featureId)) {
        return true
    }

    if (!growthbook) {
        return false
    }

    return growthbook.isOn(featureId)
}
